(function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .controller( "CommentUnsavedDialogController", CommentUnsavedDialogController );

    CommentUnsavedDialogController.$inject = ['entity', '$scope', '$uibModalInstance' ];

    function CommentUnsavedDialogController( entity, $scope, $uibModalInstance ) {
        var vm = this;

        vm.comment = entity;
        vm.modComment = angular.copy( vm.comment );

        vm.save = save;
        vm.cancel = cancel;

        function save() {
            $uibModalInstance.close( vm.modComment );
        };

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
